<template>
    <div class="mx-auto w-full max-w-screen-2xl pt-8 pb-40 px-8">
        <div class="flex space-x-8" v-if="inspectionTestPlan">
            <div class="flex-1">
                <div
                    class="text-2xl font-bold text-gray-900 border-transparent rounded shadow-none px-2 py-1 -ml-2.5 mb-0">
                    Inspection Test Plan
                </div>

                <div class="text-sm text-gray-500">
                    Reference {{ inspectionTestPlan.package_reference }} - {{ inspectionTestPlan.reference }}
                </div>

                <div class="sticky top-0 bg-white -mx-2 px-2 mb-8 z-30">
                    <inspection-test-plan-tabs
                        class="mt-8"
                        :inspection-test-plan="inspectionTestPlan"
                        :active-section-index.sync="activeSectionIndex"
                        :active-page.sync="activePage"
                        :editable="false"
                    ></inspection-test-plan-tabs>

                    <!-- IPT section header (if applicable). -->
                    <div v-if="activeSectionIndex !== null"
                         class="flex mt-8 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold" >
                        <div class="w-16 border-l border-r border-gray-200 px-2 py-1">Ref</div>
                        <div class="flex-1 border-r border-gray-200 px-2 py-1">Description</div>
                        <div class="w-20 -ml-px border-r border-gray-200 px-2 py-1">Quantity</div>
                        <div class="w-20 -ml-px border-r border-gray-200 px-2 py-1">Unit</div>
                        <div class="w-40 -ml-px border-r border-gray-200 px-2 py-1">Test Method</div>
                        <div class="w-40 -ml-px border-r border-gray-200 px-2 py-1">Minimum Frequency</div>
                    </div>
                </div>
                <ui-data-grid v-if="isPage('properties')">
                    <ui-data-grid-item label="Principle Contrator"
                                       :value="inspectionTestPlan.principleContractor"
                    ></ui-data-grid-item>
                    <ui-data-grid-item label="Contract Reference"
                                       :value="inspectionTestPlan.contractReference"
                    ></ui-data-grid-item>
                    <ui-data-grid-item autoresize label="Site Address"
                                       :value="inspectionTestPlan.siteAddress"
                                       class="col-span-12"
                    ></ui-data-grid-item>
                    <ui-data-grid-item autoresize label="Location of Works"
                                       :value="inspectionTestPlan.locationOfWorks"
                                       class="col-span-12"
                    ></ui-data-grid-item>
                </ui-data-grid>
                <inspection-test-plan-section v-else :inspection-test-plan="inspectionTestPlan"
                                              :section="inspectionTestPlan.sections[activeSectionIndex]"
                                              :sectionIndex="activeSectionIndex"
                                              :editable="false"
                >
                </inspection-test-plan-section>
            </div>
            <div class="w-72 space-y-8 relative">
                <div class="w-72 space-y-1 fixed">
                    <ui-button-new @click="edit" small primary>
                        Edit
                    </ui-button-new>
                    <div
                        style="overflow-y: auto; padding-right:12px; margin-top:12px; padding-top:12px; top:0px; height:calc(100vh - 250px)">
                        <inspection-test-plan-status-panel
                            :inspection-test-plan="inspectionTestPlan"></inspection-test-plan-status-panel>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex space-x-8" v-else>
            Loading Inspection Test plan....
        </div>
    </div>

</template>

<script>
import {InspectionTestPlan} from "@models";
import InspectionTestPlanActionPanel from "./InspectionTestPlanActionPanel.vue";
import InspectionTestPlanStatusPanel from "./InspectionTestPlanStatusPanel.vue";
import InspectionTestPlanSection from "./InspectionTestPlanSection.vue";
import UiDataGrid from "../ui/UiDataGrid.vue";
import UiDataGridItem from "../ui/UiDataGridItem.vue";

export default {
    components: {
        UiDataGridItem, UiDataGrid,
        InspectionTestPlanSection,
        InspectionTestPlanStatusPanel, InspectionTestPlanActionPanel
    },
    props: {
        item: Object,
        packageReference: String,
        edit: Function,
    },
    data() {
        return {
            inspectionTestPlan: null,
            activeSectionIndex: null,
            activePage: 'properties',
        }
    },
    computed: {},
    methods: {
        isPage(page) {
            return this.activeSectionIndex === null && this.activePage === page
        },
    },
    async mounted() {
        this.inspectionTestPlan = await InspectionTestPlan.find(this.packageReference, this.item.id);
    },
}
</script>
